import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  searchMode: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    padding: '8px',
    position: 'relative',
    borderRadius: 8,
    boxShadow: '0 2px 9px 0 rgb(0 0 0 / 19%)',
    backgroundColor: theme.palette.background.default
  },
  searchMode2: { marginTop: 320 },
  readMode: {
    display: 'flex',
    width: '100%',
    height: '100%',
    background: theme.palette.grey[800],
    alignItems: 'center'
  },
  left: {
    display: 'grid',
    gridTemplateColumns: '1fr 4fr'
  },
  searchContainer: {
    display: 'flex',
    background: theme.palette.primary.main,
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    width: 42,
    height: 42,
    marginRight: 8
  },
  icon: {
    fontSize: 30,
    color: theme.palette.primary.contrastText
  },
  svg: { color: theme.palette.grey[200], fontSize: 20 },
  smallTitle: {
    fontWeight: 600,
    color: theme.palette.grey[200],
    marginLeft: 4
  },
  right: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  btn: { height: '75%' },
  details: {
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(100% - 60px)',
    marginLeft: 6
  },
  title: { fontWeight: 600, color: theme.palette.grey[200], fontSize: 11 },
  title2: { fontWeight: 600, color: theme.palette.grey[200], fontSize: 13 },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: 4
  },
  channelName: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0'
  },
  divider: {
    margin: '8px 0',
    backgroundColor: theme.palette.grey[600]
  },
  verticalDivider: {
    backgroundColor: theme.palette.grey[600],
    margin: '0 8px'
  },
  buttonBase: {
    width: '100%'
  },
  columnSeparator: {
    width: 1,
    height: '100%',
    borderRight: 'dashed 1px #ababab',
    marginRight: 8
  },
  bottom: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 16,
    marginBottom: 8,
    padding: '0 8px'
  },
  btnText: { color: theme.palette.primary.contrastText },

  searchButton: {
    borderRadius: 8,
    width: '100%',
    height: 42
  },
  searchIcon: {
    fontSize: '24px'
  },
  currencyLabelColor: {
    color: theme.palette.primary.main,
    fontSize: 13
  },
  autocompleteBorder: {
    border: `0.5px solid ${theme.palette.grey[100]} !important`,
    borderRadius: 6
  },
  adorment: {
    right: 0,
    '& svg': {
      fontSize: '20px'
    }
  },
  currencyContainer: { marginRight: 8 },
  dateModal: {
    top: -12,
    right: 0,
    position: 'absolute',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    zIndex: 10000,
    boxShadow: '0 2px 13px 0 rgb(0 0 0 / 17%)',
    borderRadius: 9,
    backgroundColor: theme.palette.background.default
  },
  nightContainer: {
    height: 'calc(100% + 30px)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: 20,
    boxShadow: '0 2px 13px 0 rgb(0 0 0 / 17%)',
    borderRadius: 8
  },
  guestModal: {
    top: 0,
    [theme.breakpoints.down('sm')]: {
      top: 230
    },
    minWidth: 280,
    maxHeight: 460,
    position: 'absolute',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: '16px',
    zIndex: 2,
    boxShadow: '0 2px 13px 0 rgb(0 0 0 / 17%)',
    backgroundColor: theme.palette.background.default,
    borderRadius: 8
  },
  dateModalContainer: {
    display: 'grid',
    gridTemplateColumns: '15fr 1fr 15fr'
  }
}))
export default useStyles
